import { render } from "./slider.vue?vue&type=template&id=0b8cc3f4&scoped=true"
import script from "./slider.vue?vue&type=script&lang=js"
export * from "./slider.vue?vue&type=script&lang=js"

import "./slider.vue?vue&type=style&index=0&id=0b8cc3f4&scoped=true&lang=css"

import exportComponent from "/Applications/phpstudy/bjhy/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8cc3f4"]])

export default __exports__